export default {
  options: {
    doneBtnText: '知道了',
    closeBtnText: '知道了',
    nextBtnText: '知道了',
    prevBtnText: '上一个'
  },
  layout: {
    // languageSwitcher: {
    //   title: '语言切换',
    //   description: '语言状态栏中蓝色背景为当前系统语言，可以点击选中来进行切换'
    // },
    // backToOldBtn: {
    //   title: '切回旧版',
    //   description: '你可以点这里切换回旧版 OKR'
    // },
    weeklyBtn: {
      title: '周报模式',
      description: '点击后进入周报模式，可随时切换回普通模式'
    },
    myTeamWeeklyBtn: {
      title: '我的团队周报',
      description: '点击后进入我的团队周报'
    },
    myTeamOkr: {
      title: '团队OKR',
      description: '点击后查看同部门人员列表'
    }
  },
  okr: {
    create: {
      howToCreate: '如何创建 OKR，查看这里',
      primary: '创建个人 OKR，制定全年或季度工作目标及实现路径',
      remark: '注：OKR 创建后，需要点击发布，才可以生效',
      remark1: '建议至多创建3个目标，使目标更聚焦',
      image: require('@/assets/images/guide/how-to-create_zh.gif')
    },
    align: {
      self: {
        objective: {
          title: '对齐和邀请对齐',
          description: '你可以点这里来对齐他人的 OKR，或者邀请他人来对齐你的 OKR',
          doc: {
            text: '如何对齐',
            url: 'https://funplus.yuque.com/docs/share/b9edc4f2-6c07-434d-969b-223c9ef383ba'
          },
          image: require('@/assets/images/guide/how-to-align_zh.gif')
        }
      },
      other: {
        title: '对齐他人',
        description: '{\'查看他人 OKR 时，可直接在\'} {\'@\'} {\'你的目标和实现路径上点击“对齐”按钮来完成对齐\'}'
      }
    }
  },
  unpublishedWarning: {
    title: '未发布',
    description: '还有草稿没有发布，请点击发布'
  }
}
